module.exports = __webpack_public_path__ + "media/images/save-1d1d23418d39da8a87a0e36c731454ec.svg";